<template>
    <div class="h-100 w-100 overflow-auto">
        <div v-if="service" class="d-flex flex-row w-100 container-body">
            <div id="query_list" class="d-flex flex-column card p-1 h-100"
                 style="min-width:max-content; max-width: 200px;">
                <mini-button variant="light"
                             class="text-left"
                             @btnClick="openServiceInput">
                    /{{ service }}
                </mini-button>
                <v-select class="mt-1" style="width: 200px"
                          :options="entities"
                          :filterBy="filter"
                          v-model="entity"
                          @option:selected="getEntityConfig(entity)"
                ></v-select>
                <h4 class="mt-1">Entity List:</h4>
                <div class="d-flex flex-column flex-grow-1 w-100 overflow-auto">
                    <template v-for="(v,k,i) in entityConfigs">
                        <b-button :key="i"
                                  class="mb-1 text-left"
                                  variant="light"
                                  @click="entityClick(k)">
                            {{ k }}
                        </b-button>
                    </template>
                </div>
            </div>

            <div id="current_fields" class="ml-1 card p-1 overflow-auto h-100"
                 style="min-width:max-content;max-width: 200px"
                 v-if="currentExpandEntity">
                <template v-for="(f,i) of currentFields">
                    <b-button :key="i"
                              class="mt-1 text-left"
                              variant="light"
                              :title="f.key"
                              @click="fieldClick(f)">
                        {{ f.label || f.key }}
                    </b-button>
                </template>
            </div>

            <div id="config" class="ml-1 flex-grow-1 overflow-auto h-100">
                <div class="card p-1 mb-1 w-100 d-flex flex-column position-relative">
                    <h4 class="mt-1"
                        :class="target==='S'?'text-info':''"
                        @click="target = 'S'">Select:</h4>
                    <draggable v-model="selects" v-bind="{animation: 500}">
                        <transition-group class="d-flex" :class="selectsViewHorizontal?'flex-wrap':'flex-column'">
                            <div v-for="(f,i) of selects" :key="i">
                                <field-btn :field="f" class="mt-1 mr-1"
                                           with-popover allow-custom-transform
                                           :text-info="isTargetExpand(f.target)"
                                           :variant="f.disable?'outline-secondary':''"
                                           :need-alias="selectKeyCount[f.key]>1 || f.target!==from.target || hasCode(f.transform)"
                                           :as-no-need="selectKeyRestCount[f.key]<=1"
                                           :as-repeat="selectAliasCount[f.alias]>1 || selectKeyCount[f.alias]>0"
                                           :custom-btn="f.isMeasure">
                                    <template #btn="{label}">
                                        <div v-if="f.aggregation" class="text-primary">{{ f.aggregation }}(</div>
                                        {{ label }}
                                        <div v-if="f.aggregation" class="text-primary">)</div>
                                    </template>
                                    <template #popover>
                                        <div class="d-flex flex-row">
                                            <key-value-cell :value="f.key" horizontal class="mr-1">Field Key:
                                            </key-value-cell>
                                            <delete-button no-confirm variant="outline-danger" class="ml-auto"
                                                           @btnClick="selects.splice(i,1)"></delete-button>
                                        </div>
                                        <mini-input class="w-100" type="checkbox" :value.sync="f.disable"
                                                    label="For Filter" horizontal no-label-width-rate></mini-input>
                                        <mini-input class="w-100" type="checkbox" :value.sync="f.isMeasure"
                                                    label="Measure" horizontal no-label-width-rate></mini-input>
                                        <mini-input v-if="f.isMeasure" class="w-100" type="select"
                                                    :options="aggregation" :value.sync="f.aggregation"
                                                    label="Aggregation" horizontal no-label-width-rate></mini-input>
                                    </template>
                                </field-btn>
                            </div>
                        </transition-group>
                    </draggable>
                    <b-button class="position-absolute right top m-1"
                              variant="light"
                              @click="selectsViewHorizontal=!selectsViewHorizontal">
                        <i v-if="selectsViewHorizontal" class="fa-solid fa-grip"></i>
                        <i v-else class="fa-solid fa-grip-vertical"></i>
                    </b-button>
                </div>
                <div class="card p-1 mb-1 w-100 d-flex flex-column">
                    <h4 class="mt-1"
                        :class="target==='F'?'text-info':''"
                        @click="target = 'F'">From:</h4>
                    <div v-if="from && from.entity" class="mt-1">
                        <entity-btn :entity="from"
                                    :selected="currentExpandEntity===from"
                                    @btnClick="setCurrentExpandEntity(from)"/>
                        <b-button class="ml-auto" variant="outline-secondary" @click="includeAll(from)">
                            Include all
                        </b-button>
                    </div>
                </div>
                <div class="card p-1 mb-1 w-100 d-flex flex-column">
                    <h4 class="mt-1"
                        :class="target==='J'?'text-info':''"
                        @click="target = 'J'">Join:</h4>
                    <draggable v-model="join" v-bind="{animation: 500}">
                        <transition-group class="d-flex flex-column">
                            <template v-for="(j,i) of join">
                                <div class="d-flex flex-row mt-1" :key="i">
                                    <minus-btn class="mr-1" @btnClick="removeJoin(i)"/>
                                    <entity-btn :entity="j" :selected="currentExpandEntity===j"
                                                @btnClick="setCurrentExpandEntity(j)"/>
                                    <b-button class="ml-1"
                                              @click="newJoinOn(j)">
                                        ON
                                    </b-button>
                                    <div class="d-flex flex-column ml-1 join-on-cover" v-if="j.on">
                                        <template v-for="(on,ii) of j.on">
                                            <div class="d-flex flex-row mt-1 join-on-item" :key="ii">
                                                <field-btn :field="on.left"
                                                           :text-info="isTargetExpand(on.left.target)"
                                                           :warning="currentJoinOn===on&&on.isLeft"
                                                           with-popover allow-custom-transform
                                                           @btnClick="joinOnClick(on)"></field-btn>
                                                <btn-select class="ml-1 mr-1" :options="operators"
                                                            :value.sync="on.operator"></btn-select>
                                                <template v-if="!isNoValueOperator(on.operator)">
                                                    <b-button v-if="ii>0" class="mr-1" @click="changeOnRightInput(on)">
                                                        <i class="fa-solid fa-repeat"></i>
                                                    </b-button>
                                                    <b-form-input v-if="on.rightInput" v-model="on.right"
                                                                  style="width: 200px;"></b-form-input>
                                                    <field-btn v-else :field="on.right"
                                                               :text-info="isTargetExpand(on.right.target)"
                                                               :warning="currentJoinOn===on&&on.isRight"
                                                               with-popover allow-custom-transform
                                                               @btnClick="joinOnClick(on, true)"></field-btn>
                                                </template>

                                                <minus-btn class="ml-1 join-on-item-btn" @btnClick="j.on.splice(ii,1)"/>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </transition-group>
                    </draggable>
                </div>
                <div class="card p-1 mb-1 w-100 d-flex flex-column">
                    <h4 class="mt-1"
                        :class="target==='W'?'text-info':''"
                        @click="target = 'W'">Where:</h4>
                    <draggable v-model="where" v-bind="{animation: 500}">
                        <transition-group class="d-flex flex-column">
                            <template v-for="(w,i) of where">
                                <div class="d-flex flex-row mt-1" :key="i">
                                    <minus-btn class="mr-1" @btnClick="where.splice(i,1)"/>
                                    <field-btn :field="w" :text-info="isTargetExpand(w.target)"/>
                                    <btn-select :options="operators" :value.sync="w.operator"></btn-select>
                                    <template v-if="!isNoValueOperator(w.operator)">
                                        <b-form-input v-model="w.valueJson" style="width: 200px;"></b-form-input>
                                    </template>
                                </div>
                            </template>
                        </transition-group>
                    </draggable>
                </div>
                <div class="card p-1 mb-1 w-100 d-flex flex-column">
                    <h4 class="mt-1"
                        :class="target==='O'?'text-info':''"
                        @click="target = 'O'">Order By:</h4>
                    <draggable v-model="orderBy" v-bind="{animation: 500}">
                        <transition-group class="d-flex flex-column">
                            <template v-for="(o,i) of orderBy">
                                <div class="d-flex flex-row mt-1" :key="i">
                                    <minus-btn class="mr-1" @btnClick="orderBy.splice(i,1)"/>
                                    <field-btn :field="o" :text-info="isTargetExpand(o.target)"/>
                                    <sort-switch class="ml-1" :desc.sync="o.desc"></sort-switch>
                                </div>
                            </template>
                        </transition-group>
                    </draggable>
                </div>
            </div>
        </div>
        <e-logo v-else title="Query Generator"/>
        <re-b-modal ref="serviceInput"
                    header="Select Service"
                    no-close-on-backdrop
                    @hide="serviceCheck"
                    @ok="serviceOk">
            <b-overlay class="d-flex flex-row" :show="serviceLoading" spinner-small>
                <b-form-select v-model="service"
                               :options="serviceOptions" value-field="name" text-field="name"
                               class="flex-grow-1 mr-1"></b-form-select>
                <b-button variant="light" @click="getServiceList">
                    <i class="fa-solid fa-rotate-right"></i>
                </b-button>
            </b-overlay>
        </re-b-modal>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import EntityBtn from "@/components/jsc/qc-cell/EntityBtn.vue";
import FieldBtn from "@/components/jsc/qc-cell/FieldBtn.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import MinusBtn from "@/components/jsc/qc-cell/MinusBtn.vue";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ELogo from "@/components/common/display/ELogo.vue";
import {match} from "pinyin-pro";
import BtnSelect from "@/components/common/inputs/BtnSelect.vue";
import SortSwitch from "@/components/common/buttons/SortSwitch.vue";

const AS = ' as ';
export default {
    name: "SqlConfig",
    components: {
        SortSwitch,
        BtnSelect,
        ELogo,
        KeyValueCell,
        MinusBtn,
        MiniInput,
        ReBModal,
        DeleteButton,
        FieldBtn,
        EntityBtn,
        MiniButton,
        draggable
    },
    mixins: [emCommonUtilMixin],
    props: {
        config: String,
    },
    data() {
        return {
            entities: [],
            entityConfigs: {},
            queryClazzConfigLoading: false,

            serviceLoading: false,
            service: null,
            serviceOptions: [],
            entity: null,

            currentExpandEntity: null,
            currentJoinOn: null,

            target: null,
            selects: [],
            selectAdditionKey: ['disable', 'isMeasure', 'aggregation', 'transform'],
            // from: {},
            join: [],
            where: [],
            orderBy: [],
            repeatSelectKey: new Set(),

            selectsViewHorizontal: false,
            unpackLoading: false,

            aggregation: ['COUNT', 'SUM', 'AVG', 'MIN', 'MAX'],
            operators: ['=', '<>', '~~', 'NotNull', 'IsNull']
        }
    },
    computed: {
        from: {
            get() {
                return this.$store.state.queryConfigStore.currentFrom;
            },
            set(val) {
                this.$store.commit('queryConfigStore/setCurrentFrom', val);
            },
        },
        baseUri() {
            let host = process.env.VUE_APP_EM_GATEWAY_URL;
            for (let item of this.serviceOptions) {
                if (item.name === this.service) {
                    if (item.value) {
                        host = item.value;
                    }
                    break;
                }
            }
            return `${host}/${this.service}/qg`;
        },
        currentFields() {
            if (this.currentExpandEntity) {
                let key = null;
                let target = null;
                if (typeof this.currentExpandEntity === 'string') {
                    // key = this.currentExpandEntity;
                } else {
                    key = this.currentExpandEntity.entity;
                    target = this.currentExpandEntity.target;
                }
                let ec = this.entityConfigs[key];
                if (ec && ec.fields) {
                    if (target) {
                        let tL = [];
                        for (let item of ec.fields) {
                            let t = this.deepCopyObj(item);
                            t.target = target;
                            tL.push(t);
                        }
                        return tL;
                    }
                }
            }
            return [];
        },
        selectKeyCount() {
            return this._arrayValueCount(this.selects, 'key');
        },
        selectKeyRestCount() {
            return this._arrayValueCount(this.selects, 'key', item => !this.hasCode(item.alias));
        },
        selectAliasCount() {
            return this._arrayValueCount(this.selects, 'alias');
        },
    },
    watch: {
        service: {
            handler() {
                if (this.service) {
                    this.getAllEntities();
                    this.$store.commit('queryConfigStore/setCurrentService', this.service);
                }
            },
            immediate: true,
        },
        selects: {
            handler() {
                let tempList = [];
                for (let item of this.selects) {
                    if (!item.disable) {
                        tempList.push(item);
                    }
                }
                this.$emit('activeSelects', tempList);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.getServiceList();
    },
    methods: {
        getServiceList() {
            this.serviceLoading = true;
            this.$store.dispatch('dictionaryEnumStore/getDictOriginal', 'query_config_server')
                .then(res => {
                    this.serviceOptions = res;
                }).finally(() => this.serviceLoading = false);
        },
        openServiceInput() {
            this.$refs.serviceInput.showModal();
        },
        filter(option, label, search) {
            return match(label, search) != null;
        },
        serviceCheck() {
            if (!this.service) {
                this.$message.warning("must have service")
            }
        },
        serviceOk() {
            if (!this.entities || this.entities.length <= 0) {
                this.getAllEntities();
            }
        },
        getEntityConfig(...entity) {
            if (this.service && entity) {
                this.entity = null;
                this.queryClazzConfigLoading = true;
                let url = `${this.baseUri}/get/clazzConfig`;
                this.$store.dispatch('api/post', {
                    url: url,
                    data: entity
                }).then(res => {
                    if (res) {
                        for (let k in res.data) {
                            this.$set(this.entityConfigs, k, res.data[k]);
                        }
                        this.$store.commit('queryConfigStore/setEntityConfigs', this.entityConfigs);
                    }
                }).finally(() => {
                    this.queryClazzConfigLoading = false;
                    if (this.unpackLoading) {
                        this.fillLabel();
                    }
                });
            } else if (!this.service) {
                this.openServiceInput();
            } else {
                this.$message.warning("must have entity")
            }
        },
        setCurrentExpandEntity(entity) {
            this.currentExpandEntity = entity;
        },
        getAllEntities() {
            if (this.service) {
                let url = `${this.baseUri}/clazz/all`
                this.$store.dispatch('api/get', {
                    url: url,
                    commonErrorHandle: false,
                }).then(res => {
                    this.entities = res;
                    this.entities.sort();
                }).catch(() => {
                    this.entities = [];
                    this.$refs.serviceInput.showModal();
                    this.$message.error("Get Failed, seems service not available");
                });
            }
        },
        //-----------------------------------------------------------
        copyField(item) {
            return {
                key: item.key,
                label: item.label,
                target: item.target
            }
        },
        //-----------------------------------------------------------
        fieldClick(item) {
            let temp = this.copyField(item);
            switch (this.target) {
                case 'S':
                    temp.entity = item.entity;
                    this.newSelect(temp);
                    break;
                case 'J':
                    if (this.currentJoinOn) {
                        if (this.currentJoinOn.isRight) {
                            this.$set(this.currentJoinOn, 'right', temp);
                            this.$set(this.currentJoinOn, 'isRight', false);
                            break;
                        } else if (this.currentJoinOn.isLeft) {
                            this.$set(this.currentJoinOn, 'left', temp);
                            this.$set(this.currentJoinOn, 'isRight', true);
                            this.$set(this.currentJoinOn, 'isLeft', false);
                            break;
                        }
                    }
                    temp.entity = item.entity;
                    this.newSelect(temp);
                    break;
                case 'O':
                    this.newOrder(temp);
                    break;
                case 'W':
                    temp.operator = '=';
                    this.where.push(temp);
                    break;
                case 'O':
                    this.newOrder(temp);
                    break;
            }
        },
        entityClick(item) {
            if (!this.from || !this.from.target) {
                this.from = {
                    entity: item,
                    target: item
                };
            } else {
                switch (this.target) {
                    case 'F':
                        if (this.from && this.from.target !== item) {
                            let confirm = this.removeTargetWithConfirm(this.from.target);
                            if (confirm) {
                                this.from = {
                                    entity: item,
                                    target: item
                                };
                            }
                        }
                        break;
                    default:
                        this.newJoin(item);
                        break;
                }
            }
        },
        joinOnClick(on, right = false) {
            this.$set(on, 'isRight', right);
            this.$set(on, 'isLeft', !right);
            this.currentJoinOn = on;
            this.target = 'J';
        },
        //----------------------------------------------------------------
        newJoin(item) {
            if (!this.from) {
                this.$message.warning('Please choose from first');
                return;
            }
            let tempIndexList = [];
            for (let j of this.join) {
                if (j.entity === item) {
                    let indexOf = j.target.indexOf('__');
                    if (indexOf > 0) {
                        let tI = Number.parseInt(j.target.substring(indexOf + 2));
                        tempIndexList.push(tI);
                    } else {
                        tempIndexList.push(0);
                    }
                }
            }
            tempIndexList.sort();
            let index = item === this.from.entity ? 1 : 0;
            for (let ti of tempIndexList) {
                if (ti === index) {
                    index += 1;
                }
            }
            let temp = {
                entity: item,
                target: item + (index > 0 ? '__' + index : ''),
                on: []
            }
            this.join.push(temp);
            if (!this.currentExpandEntity) {
                this.setCurrentExpandEntity(temp);
            }
            this.newJoinOn(temp);
        },
        newJoinOn(join) {
            let on = {
                left: {},
                operator: '=',
                right: {},
                isLeft: true,
                isRight: false
            };
            join.on.push(on);
            this.currentJoinOn = on;
        },
        removeJoin(index) {
            let j = this.join[index];
            let confirm = this.removeTargetWithConfirm(j.target);
            if (confirm) {
                this.join.splice(index, 1);
            }
        },
        newSelect(item, alert = true) {
            for (let o of this.selects) {
                if (o.key === item.key && o.target === item.target && !this.hasCode(o.transform)) {
                    if (alert) {
                        this.$message.warning("Field existed");
                    }
                    return;
                }
            }
            this.selects.push(item);
        },
        removeTargetWithConfirm(target) {
            let got = false;
            for (let item of this.selects) {
                if (item.target === target) {
                    got = true;
                    break;
                }
            }
            if (got) {
                let c = confirm("Select items contains " + target);
                if (c) {
                    let tempList = [];
                    for (let i = this.selects.length - 1; i >= 0; i--) {
                        let item = this.selects[i];
                        if (item.target === target) {
                            tempList.push(i);
                        }
                    }
                    for (let i of tempList) {
                        this.selects.splice(i, 1);
                    }
                } else {
                    return false;
                }
            }
            return true;
        },
        newOrder(item) {
            for (let o of this.orderBy) {
                if (o.key === item.key && o.target === item.target) {
                    return;
                }
            }
            item.direction = 'DESC';
            this.orderBy.push(item);
        },
        changeOnRightInput(on) {
            this.$set(on, 'rightInput', !on.rightInput)
            if (on.rightInput) {
                on.right = '';
            } else {
                on.right = {};
            }
        },
        //----------------------------------------------------------------
        isTargetExpand(target) {
            return this.currentExpandEntity && this.currentExpandEntity.target === target;
        },
        //----------------------------------------------------------------
        gatherConfig() {
            if (!this.service) {
                return null;
            }
            let selects = [];
            for (let item of this.selects) {
                let sT = {name: this.toName(item.target, item.key, item.alias)}
                for (let k of this.selectAdditionKey) {
                    sT[k] = item[k];
                }
                selects.push(sT);
            }
            let join = [];
            for (let j of this.join) {
                let onList = [];
                for (let on of j.on) {
                    let r = this.isNoValueOperator(on.operator) ? undefined :
                        on.rightInput ? on.right : this.toName(on.right.target, on.right.key);
                    onList.push({
                        left: this.toName(on.left.target, on.left.key),
                        leftTransform: on.left.transform,
                        operator: on.operator,
                        right: r,
                        rightTransform: on.rightInput ? null : on.right.transform
                    })
                }
                if (onList.length > 0) {
                    join.push({
                        target: j.target,
                        on: onList
                    })
                }
            }
            let where = [];
            for (let item of this.where) {
                let wT = {
                    name: this.toName(item.target, item.key, item.alias),
                    operator: item.operator,
                    valueJson: item.valueJson,
                }
                where.push(wT);
            }
            let orderBy = [];
            for (let item of this.orderBy) {
                let oT = {
                    field: this.toName(item.target, item.key, item.alias),
                    direction: item.desc ? 'DESC' : 'ASC'
                }
                orderBy.push(oT);
            }
            return {
                voConfig: {
                    select: selects,
                    from: this.from.target,
                    join: join,
                    where: where,
                    orders: orderBy,
                },
                service: this.service
            };
        },
        toName(target, key, alias) {
            let s = target + "." + key;
            if (alias) {
                s += AS + alias;
            }
            return s;
        },
        breakName(name, eSet) {
            let temp = {};
            if (name) {
                let target = name;
                let di = name.indexOf('.');
                if (di > 0) {
                    let ai = name.indexOf(AS);
                    if (ai > 0) {
                        temp.alias = name.substring(ai + AS.length);
                        name = name.substring(0, ai);
                    }
                    target = name.substring(0, di)
                    temp.key = name.substring(di + 1);
                }
                let ei = target.indexOf('__');
                if (ei > 0) {
                    temp.entity = target.substring(0, ei);
                } else {
                    temp.entity = target;
                }
                temp.target = target;
                if (temp.key) {
                    let l = this.getLabel(temp)
                    if (l != null) {
                        temp.label = l;
                    } else {
                        eSet.add(temp.entity);
                    }
                }
            }
            return temp;
        },
        getLabel(t) {
            if (this.entityConfigs[t.entity]) {
                for (let item of this.entityConfigs[t.entity].fields) {
                    if (item.key === t.key) {
                        return item.label;
                    }
                }
            }
            return null;
        },
        unpackConfig(config) {
            if (!config) {
                this.selects = [];
                this.from = {};
                this.join = [];
                this.orderBy = [];
                this.where = [];
                this.setCurrentExpandEntity(null);
                if (!this.service) {
                    this.openServiceInput();
                }
            } else {
                this.unpackLoading = true;
                this.service = config.moduleCode;
                let eSet = new Set();
                let all = JSON.parse(config.configuration);
                //vo config
                let obj = all.voConfig;
                let sL = [];
                for (let item of obj.select) {
                    if (typeof item === 'string') {//兼容旧版
                        sL.push(this.breakName(item, eSet));
                    } else {
                        let temp = this.breakName(item.name, eSet);
                        for (let k of this.selectAdditionKey) {
                            temp[k] = item[k];
                        }
                        sL.push(temp);
                    }
                }
                let jL = [];
                for (let item of obj.join) {
                    let oL = [];
                    for (let o of item.on) {
                        let temp = {
                            left: {
                                ...this.breakName(o.left, eSet),
                                transform: o.leftTransform
                            },
                            operator: o.operator,
                        };
                        let right = this.breakName(o.right, eSet);
                        if (!right.key) {
                            temp.rightInput = true;
                            temp.right = o.right;
                        } else {
                            right.transform = o.rightTransform;
                            temp.right = right;
                        }
                        oL.push(temp);
                    }
                    let j = this.breakName(item.target);
                    jL.push({
                        entity: j.entity,
                        target: j.target,
                        on: oL
                    })
                }
                this.selects = sL;
                this.from = this.breakName(obj.from, eSet);
                this.join = jL;
                let wL = [];
                if (obj.where) {
                    for (let item of obj.where) {
                        let temp = this.breakName(item.name, eSet);
                        temp.operator = item.operator;
                        temp.valueJson = item.valueJson;
                        wL.push(temp);
                    }
                }
                this.where = wL;
                let oL = [];
                if (obj.orders) {
                    for (let item of obj.orders) {
                        let temp = this.breakName(item.field, eSet);
                        temp.desc = item.direction === 'DESC';
                        oL.push(temp);
                    }
                }
                this.orderBy = oL;
                if (eSet.size > 0) {
                    this.getEntityConfig(...Array.from(eSet));
                } else {
                    this.unpackLoading = false;
                }
            }
        },
        fillLabel() {
            for (let item of this.selects) {
                item.label || this.$set(item, 'label', this.getLabel(item));
            }
            for (let j of this.join) {
                for (let on of j.on) {
                    on.left.label || this.$set(on.left, 'label', this.getLabel(on.left))
                    !on.rightInput && (on.right.label || this.$set(on.right, 'label', this.getLabel(on.right)))
                }
            }
            for (let item of this.orderBy) {
                item.label || this.$set(item, 'label', this.getLabel(item));
            }
            this.unpackLoading = false;
        },
        //----------------------------------------------------------------
        includeAll(item) {
            if (item && item.entity && item.target) {
                if (this.entityConfigs[item.entity]) {
                    for (let o of this.entityConfigs[item.entity].fields) {
                        let temp = {
                            key: o.key,
                            label: o.label,
                            entity: item.entity,
                            target: item.target
                        }
                        this.newSelect(temp, false);
                        if (o.key === 'updatedTime') {
                            this.newOrder(temp);
                        }
                    }
                }
            }
        },
        isNoValueOperator(op) {
            return ['NotNull', 'IsNull'].some(o => o === op);
        },
    },
    beforeDestroy() {
        this.$store.commit('queryConfigStore/setCurrentService', null);
    }
}
</script>

<style scoped>
.join-on-cover div:first-child {
    margin-top: 0 !important;
}

.join-on-item:hover .join-on-item-btn {
    display: block !important;
}

.join-on-item-btn {
    display: none !important;
}

.container-body {
    height: 100%;
}
</style>
